import React, {useContext} from 'react';
import {LanguageContext, LanguageContextProps} from '../context/language-context';

export function useLanguage():LanguageContextProps {
    const context = useContext(LanguageContext);
    if(!context) throw new Error('useLanguage must be used inside <LanguageProvider/>');
    return useContext(LanguageContext);
}